import styled from "styled-components";
import {NO_JACKPOT} from "../css-classes";

export const GameDetailsNameBox = styled.div`
  text-align: center;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  color: ${props => props.theme.colors.textLight};
  font-family: ${props => props.theme.font.family.body};
  
  line-height: 1;
  
  &.${NO_JACKPOT}{
    padding-bottom: 1.5rem;
  }
`;